var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-end-line"},[_c('div',{staticClass:"end-line"},[_c('span',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }